module.exports = __webpack_public_path__ + "static/media/lease-a-truck-clients.f72492fd.png";